var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Vue logo","src":require("./assets/logo.png")}}),_c('HelloWorld',{attrs:{"msg":"上海乐狮文化传播有限公司"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }